module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/3_52088cd21af92ef84ac8a98dd40945ea.png";